import _get from 'lodash/get';
import _findKey from 'lodash/findKey';
import { blankInitialValues } from 'pages/Events/util/constants';
import { createSelector } from 'reselect';
import moment from 'moment';
// utils
import { formatDateForEdit } from '../../util/formDataUtil';

// returns array of ordered ids
export const getOrderedEventIds = state => _get(state, 'events.events.orderedIds', []);

// returns obj with eventIds as keys
export const getEventsById = state => _get(state, 'events.events.byId', {});

// full event object in order
export const getOrderedEvents = state => {
  const orderedIds = getOrderedEventIds(state);
  const byId = getEventsById(state);
  const orderedEvents = orderedIds.map(id => byId[id]);
  return orderedEvents;
};

// active selected event ID
export const getSelectedId = state => _get(state, 'events.events.selectedId');

// initialvalues needed by EventForm
const newDateValue = { date: moment.utc() };
const newStartAtValue = { start_at: { hour: 18, minute: 0 } };
export const getInitialValues = createSelector(
  getSelectedId,
  getEventsById,
  (selectedId, eventsById) => {
    const event = eventsById[selectedId];
    const initialValues = event
      ? Object.assign(event, formatDateForEdit(event))
      : Object.assign(blankInitialValues, newDateValue, newStartAtValue);
    return initialValues;
  }
);

export const getCurrentZoomEvent = state => _get(state, 'events.events.currentZoomEvent');

export const getEventById = (state, id) => _get(getEventsById(state), id, {});

export const getEventByHash = (state, hash) => {
  const eventsById = getEventsById(state);
  const id = _findKey(eventsById, { hash });
  return _get(eventsById, id, {});
};

// ** check if google address lookup has updated the address fields
//    - rely on changes to google_place_id
const addressObj = state => state.events.events.address;
const googleId = state => state.events.events.address.google_place_id;

export const getAddressBusy = state => state.events.events.address.busy;
// eslint-disable-next-line no-unused-vars
export const getUpdatedAddress = createSelector(googleId, addressObj, (placeId, address) => {
  return address;
});



// WEBPACK FOOTER //
// ./src/selectors/events/eventsSelectors.js